import type { Company, Contact, Deal, Partner } from "../types";
import { RecordEmails } from "./RecordEmails";
import { SendEmailButton } from "./SendEmailButton";
import {
  useCompanyEmailProps,
  useContactEmailProps,
  useDealEmailProps,
  usePartnerEmailProps,
  type RecordEmailProps,
} from "./useRecordEmailProps";

/** The « E-mails » tab and « Envoyer un e-mail » button of each kind of record. */

const EmailsTab = ({ filter, ...props }: RecordEmailProps) => (
  <RecordEmails filter={filter} {...props} />
);

const SendButton = ({
  filter: _filter,
  ...props
}: RecordEmailProps & { className?: string }) => <SendEmailButton {...props} />;

export const CompanyEmailsTab = ({ company }: { company: Company }) => (
  <EmailsTab {...useCompanyEmailProps(company)} />
);

export const CompanySendEmailButton = ({ company }: { company: Company }) => (
  <SendButton {...useCompanyEmailProps(company)} />
);

export const ContactEmailsTab = ({ contact }: { contact: Contact }) => (
  <EmailsTab {...useContactEmailProps(contact)} />
);

export const ContactSendEmailButton = ({ contact }: { contact: Contact }) => (
  <SendButton {...useContactEmailProps(contact)} />
);

export const PartnerEmailsTab = ({ partner }: { partner: Partner }) => (
  <EmailsTab {...usePartnerEmailProps(partner)} />
);

export const PartnerSendEmailButton = ({ partner }: { partner: Partner }) => (
  <SendButton {...usePartnerEmailProps(partner)} />
);

export const DealEmailsTab = ({ deal }: { deal: Deal }) => (
  <EmailsTab {...useDealEmailProps(deal)} />
);

export const DealSendEmailButton = ({ deal }: { deal: Deal }) => (
  <SendButton {...useDealEmailProps(deal)} />
);
